// extracted by mini-css-extract-plugin
module.exports = {"container":"dd31006766--container--cAtWX","container-mobile":"dd31006766--container-mobile--mhLiX","list":"dd31006766--list--Y3zFO","read-more":"dd31006766--read-more--yplb6"};